import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import AiMessagingContentFilesController from 'uplisting-frontend/pods/ai-messaging/content-files/controller';

export default class AiMessagingContentFilesRoute extends ProtectedRoute {
  @service('repositories/ai-knowledge-base-file')
  fileRepository!: Services['repositories/ai-knowledge-base-file'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  model() {
    return hash({
      files: this.fileRepository.findAll(),
      properties: this.propertyRepository.findAll(),
    });
  }

  setupController(
    controller: AiMessagingContentFilesController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);

    if (controller.propertyIds?.length) {
      controller.activeTab = 'property';
    }

    if (controller.highlightFileId) {
      controller.scrollToHighlightedFile();
    }

    if (controller.hasProcessingFiles) {
      controller.pollProcessingFiles.perform();
    }
  }

  resetController(
    controller: AiMessagingContentFilesController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.pollProcessingFiles.cancelAll();

      Object.assign(controller, {
        searchQuery: '',
        propertyIds: [],
        highlightFileId: undefined,
        activeTab: 'global',
        isFileUploadPanelOpen: false,
        isDeleteModalOpen: false,
        fileToDelete: undefined,
        deleteQaPairs: false,
      });
    }
  }
}

export type AiMessagingContentFilesRouteModel =
  RouteModel<AiMessagingContentFilesRoute>;
